import "./vacancy.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import ShareActions from "@frontend/js/Components/Shared/ShareActions/ShareActions";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import { resolvePreferredLocale } from "@frontend/js/utils/locale";
import ArrowNextIcon from "@frontend/images/icons/ArrowNextIcon";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import { usePage } from "@inertiajs/react";
import useT from "@frontend/js/hooks/useT";
import useRoute from "@frontend/js/hooks/useRoute";

export default function Vacancy({ page, resource, meta = {} }) {
    const { t } = useT("site");
    const route = useRoute();
    const pageProps = usePage().props;
    const locale = pageProps?.currentLocale;
    const vacancy = resource?.data;
    const title = vacancy?.title || "";
    const vacancyDate = vacancy?.date || "";
    const pageTitle = page?.title?.[locale] || "";
    const pageHref = route("frontend.page", { page: page?.slug });

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="vacancy page-shell">
                    <PageTitleBreadcrumb
                        title={title}
                        parentTitle={pageTitle}
                        parentHref={pageHref}
                    />
                    <div className="vacancy__container">
                        <div className="vacancy__container__text">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: vacancy?.content,
                                }}
                            />
                        </div>
                        <div className="vacancy__container__navigation">
                            <span className="vacancy__container__navigation__date">
                                {vacancyDate}
                            </span>
                            <ShareActions
                                title={t("share-label")}
                                copyLabel={t("copy-link-label")}
                                copiedLabel={t("link-copied-label")}
                                channels={[
                                    {
                                        id: "facebook",
                                        label: t("facebook-label"),
                                    },
                                    {
                                        id: "twitter",
                                        label: t("twitter-label"),
                                    },
                                    {
                                        id: "linkedin",
                                        label: t("linkedin-label"),
                                    },
                                ]}
                            />
                            <p>{t("vacancy-apply-button-label")}</p>
                            {vacancy?.breeze_link ? (
                                <a
                                    className="vacancy__container__navigation__button"
                                    href={vacancy.breeze_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t("vacancy-apply-button-text")}{" "}
                                    <ArrowNextIcon />
                                </a>
                            ) : (
                                <button className="vacancy__container__navigation__button">
                                    {t("vacancy-apply-button-text")}{" "}
                                    <ArrowNextIcon />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </SiteLayout>
        </>
    );
}
